// all fields for stips form
export default {
  inputStips: [
    {
      display: "Provide the following information:",
      inputType: "title",
      required: false,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "use_of_funds",
      display: "Use of Funds",
      inputType: "dropdown",
      options: [],
      required: false,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "department_of_transportation_number",
      display: "Department of Transportation Number",
      inputType: "text",
      required: false,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "federal_tax_id_number",
      display: "Federal Tax ID Number",
      inputType: "text",
      required: false,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "valid_phone_number",
      display: "Valid Phone Number",
      inputType: "text",
      required: false,
      useMask: true,
      placeHolder: "(999)999-9999",
      maxLength: 10
    }
  ],
  nonInputStips: [
    {
      display: "Work with the merchant to complete the following:",
      inputType: "title",
      required: false,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "merchant_interview",
      display: "Merchant Interview",
      inputType: "none",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "bank_verification",
      display: "Bank Verification",
      inputType: "none",
      required: false,
      useMask: false,
      placeHolder: "",
    },
  ],
  uploadStips: [
    {
      display: "Upload the following stipulations:",
      inputType: "title",
      required: false,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "drivers_license",
      display: "Drivers License",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "proof_of_ownership",
      display: "Proof of Ownership",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "month_to_date",
      display: "Month to Date",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "voided_check",
      display: "Voided Check",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "accounts_receivable_report_invoices",
      display: "Accounts Receivable Report/Invoices",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "balance_sheet",
      display: "Balance Sheet",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "tax_return",
      display: "Tax Return",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "signed_contracts",
      display: "Signed Contracts",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "tax_guard",
      display: "Tax Guard",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
    {
      modelVal: "payback_months",
      display: "Payback Months",
      inputType: "file",
      required: true,
      useMask: false,
      placeHolder: "",
    },
  ],
};
